import React, { useState } from "react";

function InstallerPackCustomerDetailsPhotos({
  sitePlan,
  roofMeasurements,
  panelLayout,
  optimiserLayout,
}) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);

  const handleSelectedImage = (e) => {
    setSelectedImage(e.target.src.replace(/[^a-z]/g, ""));
    setSelectedImageUrl(e.target.src);
  };

  return (
    <div>
      {sitePlan && (
        <div className="mb-4 mt-4">
          <p className="bold text-left">Site Plan</p>
          <div
            type="button"
            data-toggle="modal"
            data-target={`#${sitePlan.replace(/[^a-z]/g, "")}`}
            onClick={handleSelectedImage}
            className="installerPackPhotoContainer m-3"
          >
            <img src={sitePlan} alt="" className="img img-fluid" />
          </div>
        </div>
      )}
      {roofMeasurements && (
        <div className="mb-4">
          <p className="bold text-left">Roof Measurements</p>
          <div
            type="button"
            data-toggle="modal"
            data-target={`#${roofMeasurements.replace(/[^a-z]/g, "")}`}
            onClick={handleSelectedImage}
            className="installerPackPhotoContainer m-3"
          >
            <img src={roofMeasurements} alt="" className="img img-fluid" />
          </div>
        </div>
      )}
      {panelLayout && (
        <div className="mb-4">
          <p className="bold text-left">Panel Layout (string)</p>
          <div
            type="button"
            data-toggle="modal"
            data-target={`#${panelLayout.replace(/[^a-z]/g, "")}`}
            onClick={handleSelectedImage}
            className="installerPackPhotoContainer m-3"
          >
            <img src={panelLayout} alt="" className="img img-fluid" />
          </div>
        </div>
      )}
      {optimiserLayout && (
        <div className="mb-4">
          <p className="bold text-left">Optimiser Layout</p>
          <div
            type="button"
            data-toggle="modal"
            data-target={`#${optimiserLayout.replace(/[^a-z]/g, "")}`}
            onClick={handleSelectedImage}
            className="installerPackPhotoContainer m-3"
          >
            <img src={optimiserLayout} alt="" className="img img-fluid" />
          </div>
        </div>
      )}
      <div
        className="modal fade"
        id={selectedImage}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" data-dismiss="modal">
            <div className="modal-body">
              <img src={selectedImageUrl} alt={selectedImage} width="100%" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InstallerPackCustomerDetailsPhotos;
